import {
  Button,
  CircularProgress,
  Divider,
  Typography,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormGroup,
  FormControl,
  FormControlLabel,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import toast from "react-hot-toast";
import { useMutation, useQuery, useQueryClient } from "react-query";
import fetcher from "../../api/swr_fetcher";
import { useDialog } from "../../contexts/DialogProvider";
import { copyTextAndSendToApp } from "../../services/appMethods";
var QRCode = require("qrcode.react");

export default function CryptoDepositNetworkTab({
  coin,
  network,
  addressPresent,
  minDepositAmount,
  networkConfirmation,
  isLoading,
}) {
  const [openDialog, closeDialog] = useDialog();
  const queryClient = useQueryClient();
  function addZeroes(num) {
    return num.toLocaleString("en", {
      useGrouping: false,
      minimumFractionDigits: 2,
    });
  }

  const getAddress = useQuery(
    ["getAddress", addressPresent, network?.networkCoinId],
    () =>
      fetcher(
        "/v1/transfers/getAddress/" + network.networkCoinId.toLowerCase()
      ).then((res) => res),
    {
      enabled: Boolean(addressPresent) && Boolean(network?.networkCoinId),
      onSettled: () => {
        // window.dispatchEvent(new CustomEvent("resize"));
      },
    }
  );

  const getAddressMutation = useMutation(
    ["getAddressMutation"],
    (networkCoinId) =>
      fetcher("/v1/transfers/getAddress/" + networkCoinId).then((res) => res),
    {
      onSettled: () => {
        // window.dispatchEvent(new CustomEvent("resize"));
      },
    }
  );

  const address = getAddress.data?.depositAddress;
  const tagOrMemo = getAddress.data?.tagOrMemo;

  const handleGenerateNetworkAddress = (network, tokenType, networkCoinId) => {
    openDialog({
      children: (
        <>
          <DialogTitle className="pb-0">
            <h3>
              <strong className="text-pb-primary-100">
                Confirm Network Selection
              </strong>
            </h3>
          </DialogTitle>
          <form
            required
            component="fieldset"
            onSubmit={async (e) => {
              e.preventDefault();

              try {
                await getAddressMutation.mutateAsync(
                  networkCoinId.toLowerCase()
                );
                queryClient.refetchQueries(["coinBalance"]);
                toast.success("Network address generated successfully.", {
                  id: "network",
                });
                closeDialog();
              } catch (e) {
                closeDialog();
                let readableError = e.info?.detail?.match(/"([^']+)"/)[1];

                toast.error(readableError, {
                  id: "network",
                });
              }
            }}
          >
            <DialogContent className="pb-0">
              <Typography className="font-light mb-3">
                Deposit{" "}
                <strong>
                  only via the "{network}{" "}
                  {tokenType?.length > 0 ? `(${tokenType})` : `(${coin})`}"
                  blockchain to this address.
                </strong>
              </Typography>
              <Typography className="font-light mb-4">
                Deposits via any other network (Blockchain){" "}
                <strong>will be lost forever and cannot be recovered.</strong>
              </Typography>
              <div className="w-full">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox name="first" required color="primary" />}
                    label={<p className="text-sm md:text-base">I understand</p>}
                  />
                </FormGroup>
              </div>
            </DialogContent>
            <DialogActions
              style={{ paddingBottom: "30px", paddingRight: "20px" }}
            >
              <Button
                className="w-full md:w-auto"
                variant="outlined"
                onClick={() => {
                  closeDialog();
                }}
                color="primary"
              >
                Cancel
              </Button>{" "}
              <Button
                className="w-full md:w-auto"
                type="submit"
                variant="contained"
                color="primary"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Continue
              </Button>
            </DialogActions>{" "}
          </form>
        </>
      ),
    });
  };
  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center my-2 ">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <div className="dark:text-gray-400 text-gray-600 flex  flex-wrap  md:flex-nowrap">
          <div className={`${getAddress.isSuccess && "md:w-[470px]  "} w-full`}>
            {getAddress.isSuccess ? (
              <div className="  mb-4 ">
                <div className=" mb-2">
                  <div className="mb-2">
                    <p>Copy this wallet address</p>
                  </div>
                  <div className=" flex gap-x-3 items-center flex-wrap">
                    <div
                      className="flex-1 bg-gray-300 dark:bg-gray-700 p-2 rounded-md"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography noWrap>{address} </Typography>
                    </div>
                    <div className="w-1/4 md:w-auto">
                      <Button
                        disableElevation
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          toast.success("Network address copied", {
                            id: "network-add",
                          });
                          copyTextAndSendToApp(address);
                        }}
                        className="font-bold text-white capitalize w-full"
                      >
                        Copy
                      </Button>
                    </div>
                  </div>
                </div>
                {Boolean(tagOrMemo) && (
                  <div className=" mb-2">
                    <div className="mb-2">
                      <p>Tag or Memo</p>
                    </div>
                    <div className=" flex gap-x-3 items-center flex-wrap">
                      <div
                        className="flex-1 bg-gray-300 dark:bg-gray-700 p-2 rounded-md"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Typography noWrap>{tagOrMemo} </Typography>
                      </div>
                      <div className="w-1/4 md:w-auto">
                        <Button
                          disableElevation
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            toast.success("Tag/Memo copied", {
                              id: "network-add",
                            });
                            copyTextAndSendToApp(tagOrMemo);
                          }}
                          className="font-bold text-white capitalize w-full"
                        >
                          Copy
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                <Divider className="md:hidden mt-4" />
              </div>
            ) : (
              <Button
                disableElevation
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => {
                  handleGenerateNetworkAddress(
                    network.network,
                    network.tokenType,
                    network.networkCoinId
                  );
                }}
                className="font-bold text-white capitalize w-full mb-4"
              >
                Generate Network Address
              </Button>
            )}
            <div className="flex  gap-x-5 flex-wrap justify-between">
              <div className="flex flex-col gap-y-2 flex-wrap">
                <p>Minimum deposit amount</p>
                <p>Network confirmations</p>
              </div>
              <div className="text-right flex flex-col gap-y-2">
                <p>
                  {addZeroes(minDepositAmount)} {coin}
                </p>
                <p>{networkConfirmation} </p>
              </div>
            </div>
          </div>

          {getAddress.isSuccess && (
            <div className=" flex-1 flex mt-5 md:mt-0 md:justify-center whitespace-nowrap flex-wrap">
              <Divider
                orientation="vertical"
                className="hidden md:block mx-6"
              />
              <Divider className="md:hidden mb-4 w-full" />

              <div className="flex flex-col gap-y-3 ">
                <div>Scan this QR Code</div>
                <div className="bg-white rounded-lg p-1 flex justify-center items-center w-[120px] h-[120px] shadow-md">
                  <QRCode value={address} size={105} />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
